<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-aed-pendingMoveResend"
    >
      <div slot="header">
        <h2
          class="o-heading o-heading--size-2 o-heading--border o-heading--icon"
        >
          <svg
            class="o-heading__icon o-svg-icon"
            viewBox="0 0 64 64"
            type="image/svg+xml"
          >
            <use xlink:href="spritemap.svg#sprite-check-bold"></use>
          </svg>
          {{ translationsOwnerModal.resendConfirmationEmailTitle }}
        </h2>
      </div>

      <div slot="body">
        <div class="o-grid o-grid--gutter-normal">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              {{ translationsOwnerModal.resendConfirmationEmailBody }}
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("translations", {
      translationsOwnerModal: "ownerModal",
      translationsCustom: "custom"
    })
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit("close");
    }
  },
  props: {
    showResendConfirmationModal: {
      default: false,
      required: true
    }
  },
  created() {
    this.$nextTick(() => {
      this.showModal = this.showResendConfirmationModal;
    });
  }
};
</script>
